export default "__VITE_ASSET__adc27258__"